// categoryOptions.js
const categoryOptions = [
    {
      value: "work",
      label: { en: "Work", th: "งาน" },
      subcategories: [
        { value: "create", label: { en: "Create & Thrive", th: "สร้างสรรค์/ขับเคลื่อนชีวิต" } },
        { value: "mission", label: { en: "Mission", th: "ภารกิจวันนี้" } },
        { value: "value", label: { en: "Value Creation", th: "เติมคุณค่า" } },
        { value: "career", label: { en: "Career Journey", th: "เส้นทางอาชีพ" } },
      ]
    },
    {
      value: "family",
      label: { en: "Family", th: "ครอบครัว" },
      subcategories: [
        { value: "cherished", label: { en: "Cherished Moments", th: "ช่วงเวลาดีๆ" } },
        { value: "home", label: { en: "Home Time", th: "บ้านของหัวใจ" } },
        { value: "connections", label: { en: "Connections", th: "สัมพันธ์สำคัญ" } },
        { value: "together", label: { en: "Togetherness", th: "เวลาด้วยกัน" } },
      ]
    },
    {
      value: "health",
      label: { en: "Health", th: "สุขภาพ" },
      color: "#34d399",
      subcategories: [
        { value: "selfcare", label: { en: "Self-Care", th: "ดูแลตัวเอง" } },
        { value: "mindbody", label: { en: "Mind & Body", th: "ใจและกายแข็งแรง" } },
        { value: "recharge", label: { en: "Recharge", th: "เติมพลังชีวิต" } },
        { value: "wellness", label: { en: "Wellness Time", th: "สุขภาพดีทุกวัน" } },
      ]
    },
    {
      value: "learning",
      label: { en: "Learning", th: "การเรียนรู้" },
      color: "#fde68a",
      subcategories: [
        { value: "grow", label: { en: "Grow Everyday", th: "เติบโตทุกวัน" } },
        { value: "discovery", label: { en: "Discovery", th: "ค้นพบใหม่" } },
        { value: "development", label: { en: "Self-Development", th: "พัฒนาตัวเอง" } },
        { value: "wisdom", label: { en: "Wisdom Bank", th: "สะสมปัญญา" } },
      ]
    },
    {
      value: "rest",
      label: { en: "Rest", th: "พักผ่อน" },
      color: "#a1a1aa",
      subcategories: [
        { value: "pause", label: { en: "Pause & Breathe", th: "หยุดพักใจ" } },
        { value: "balance", label: { en: "Balance", th: "คืนสมดุล" } },
        { value: "recharge", label: { en: "Recharge", th: "พักชาร์จพลัง" } },
        { value: "restful", label: { en: "Restful Time", th: "เวลาพักใจ" } },
      ]
    },
    {
      value: "other",
      label: { en: "Other", th: "อื่น ๆ" },
      color: "#a78bfa",
      subcategories: [
        { value: "colorful", label: { en: "Colorful Life", th: "หลากหลายสีสัน" } },
        { value: "special", label: { en: "Special Moments", th: "เรื่องราวพิเศษ" } },
        { value: "space", label: { en: "Open Space", th: "พื้นที่ว่าง" } },
        { value: "joy", label: { en: "Little Joys", th: "ความสุขเล็ก ๆ" } },
      ]
    },
  ];
  export default categoryOptions;